import { RouteComponentProps } from '@reach/router';
import { ResourcesApi } from 'api/resourcesApi';
import EqualHeightsList from 'components/resources/EqualHeightsList';
import ResourcePageStatus from 'components/resources/ResourcePageStatus';
import {
  categoryPath,
  isPageData,
  ResourcesRouteParams,
  resourcesByActivityImage,
  resourcesByActivityPath,
  usePageTitle,
  useResourcesPage,
} from 'components/resources/resourcesHelpers';
import ResourceSearchBox from 'components/resources/ResourceSearchBox';
import ResourceTile from 'components/resources/ResourceTile';
import SubjectSiteContainerFixed from 'components/subjectSite/SubjectSiteContainerFixed';
import SubjectSiteLayout from 'components/subjectSite/SubjectSiteLayout';
import React from 'react';

type Props = RouteComponentProps<ResourcesRouteParams>;

const AwesomeStuff: React.FC<Props> = ({ subject: subjectCode }) => {
  const result = useResourcesPage(subjectCode, ResourcesApi.getCategories, '');
  usePageTitle(
    isPageData(result) ? `${result.subject.name} - Awesome Stuff` : null
  );

  if (!isPageData(result)) return <ResourcePageStatus result={result} />;

  const { subject, labels, details } = result;
  const code = subject.internalCode;

  return (
    <SubjectSiteLayout colorCss="Blue_GSFPE">
      <SubjectSiteContainerFixed className="ResourceBankLanding">
        <div className="WidthContent">
          <div className="TitleAndSearchWrapper">
            <h1 className="Title">Awesome Stuff</h1>
          </div>
          <div className="TitleAndSearchWrapper">
            <ResourceSearchBox
              subjectCode={code}
              placeholder="Please enter search..."
            />
          </div>
          <div className="VirtualPECupboard">
            <EqualHeightsList
              className="WarpperActivity WrapperList01"
              cardsSource={details}
            >
              <ResourceTile
                className="Item ItemList01"
                colorCSS="Purple"
                name={labels.ResourcesByActivity ?? ''}
                imageSrc={resourcesByActivityImage(subject)}
                imageAlt="EYFS"
                to={resourcesByActivityPath(code)}
                bButtonInImage
              />
              {details.resourceCategories.map((category) => (
                <React.Fragment key={category.resourceCategoriesId}>
                  {' '}
                  <ResourceTile
                    className="Item ItemList01"
                    colorCSS={category.colorCSS}
                    name={category.name}
                    imageSrc={category.imagePath}
                    imageAlt={category.name}
                    to={categoryPath(code, category.resourceCategoriesId)}
                  />
                </React.Fragment>
              ))}
            </EqualHeightsList>
          </div>
        </div>
      </SubjectSiteContainerFixed>
    </SubjectSiteLayout>
  );
};

export default AwesomeStuff;
